export class Progress {
  private static enabled = false;
  private static a = 0.1;
  private static startTime;
  private static totalLoading = 0;
  private static leftLoading = 0;
  private static loadingPercentage = 0;

  constructor() {
  }

  static begin() {
    this.a = 0.1;
    this.leftLoading = 0;
    this.totalLoading = 0;
    this.loadingPercentage = 0;
    this.startTime = new Date().getTime();
    this.enabled = true;
  }

  static addLoading(bytes) {
    this.totalLoading += bytes;
    this.leftLoading += bytes;
  }

  static removeLoading(bytes) {
    this.leftLoading -= bytes;
  }

  static getProgress(): string {
    if (this.totalLoading==0) {
      return '';
    } else {
      if (this.a < 1.0) {
        this.a = Math.min(1, ((new Date().getTime() - this.startTime) / 20000));
      }
      this.loadingPercentage = Math.max(this.loadingPercentage, Math.floor(100 * ((this.totalLoading - this.leftLoading) / this.totalLoading) * this.a));
      return this.loadingPercentage + '%';
    }
  }

  static isEnabled() {
    return this.enabled;
  }

  static end() {
    this.enabled = false;
  }

}

